// Centralized API configuration
// Defaults to same-origin relative /api so production builds work when the
// backend serves the frontend. Set REACT_APP_API_URL to override (e.g., for
// a separate API host). In dev, CRA's package.json "proxy" forwards /api
// to http://localhost:3001.
const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : '/api';

export default API_URL;
